module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.dataList && _vm.dataList.length > 0) ? _c('div', {
    staticClass: "news"
  }, _vm._l((_vm.dataList), function(item) {
    return _c('div', {
      key: item.wid,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "flex-center-between"
    }, [_c('div', {
      staticClass: "flex-col-center"
    }, [_c('div', {
      staticClass: "dots"
    }), _vm._v(" "), _c('div', {
      staticClass: "title",
      attrs: {
        "title": item.TITLE
      },
      on: {
        "click": function($event) {
          return _vm.openDetail(item.WID)
        }
      }
    }, [_vm._v(_vm._s(item.TITLE))])]), _vm._v(" "), _c('p', {
      staticClass: "time",
      attrs: {
        "title": item.CREATE_TIME.slice(0, 10)
      }
    }, [_vm._v(_vm._s(item.CREATE_TIME.slice(0, 10)))]), _vm._v(" "), _c('p', {
      staticClass: "time",
      staticStyle: {
        "margin-left": "1rem"
      },
      attrs: {
        "title": item.READNUM
      }
    }, [_vm._v("浏览量：" + _vm._s(item.READNUM ? item.READNUM : 0))])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.dataList && _vm.dataList.length > 0) ? _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "layout": "prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dataList && _vm.dataList.length == 0) ? _c('div', {
    staticClass: "empty"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/assets/empty.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂无数据")])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3576de76!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/news.vue
// module id = 566
// module chunks = 0